import {Injectable} from '@angular/core';
import {modelFormsForResource as projectForms} from '@catdetails/shared/model-forms-for-resource.map';
import {modelFormsForWizard as projectWizardForms} from '@catdetails/shared/model-forms-for-wizard.map';
import {modelFormsForResource as featureForms} from '@catfeatures/shared/model-forms-for-resource.map';
import {modelFormsForWizard as featureWizardForms} from '@catfeatures/shared/model-forms-for-wizard.map';

@Injectable()
export class ResourceTargetsService {
  getMap() {
    return new Map([
      ...Array.from(featureForms.entries()),
      ...Array.from(projectForms.entries()),
    ]);
  }
}

@Injectable()
export class ResourceWizardTargetsService {
  getMap() {
    return new Map([
      ...Array.from(featureWizardForms.entries()),
      ...Array.from(projectWizardForms.entries()),
    ]);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/core/types/services.ts